import { BrandColor, BrandColorPalette } from 'packages/store/brandColors/types';

export type BrandColorOnElement = BrandColor & { paletteName: string };

export const getExistingBrandColor = (palettes: BrandColorPalette[], colorId: number): BrandColorOnElement | null => {
    const brandColor = palettes.reduce((result, palette) => {
        const assignedColor = palette.brandColors.find((color) => color.id === colorId);

        if (assignedColor) {
            return { ...result, ...assignedColor, paletteName: palette.name };
        }

        return result;
    }, {} as BrandColorOnElement);

    return Object.keys(brandColor).length ? brandColor : null;
};

export default getExistingBrandColor;
